import Reveal from "../Reveal";
import SectionHeading from "../SectionHeading";
import { useCopy } from "../../i18n/useCopy";

/**
 * Frequently asked questions (native <details> for accessibility).
 *
 * @component
 */

const Faq = () => {
  const t = useCopy();
  return (
  <section className="homeSection container" aria-labelledby="faq-title">
    <SectionHeading eyebrow={t.sections.faq.eyebrow} title={t.sections.faq.title} id="faq-title" />
    <div className="faq">
      {t.faq.map((item, i) => (
        <Reveal as="details" key={item.q} delay={i * 0.05}>
          <summary>
            <h3>{item.q}</h3>
          </summary>
          <p>{item.a}</p>
        </Reveal>
      ))}
    </div>
  </section>
  );
};

export default Faq;
